import React from 'react';
import { type StyleProp, type ViewStyle } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useSkeletonContext } from './SkeletonGroup';
import { useSkeletonPulse } from './useSkeletonPulse';
import { useSkeletonBoneColor } from './skeletonColors';

interface SkeletonCircleProps {
  size: number;
  style?: StyleProp<ViewStyle>;
}

export const SkeletonCircle: React.FC<SkeletonCircleProps> = React.memo(({
  size,
  style,
}) => {
  const context = useSkeletonContext();
  const fallbackOpacity = useSkeletonPulse();
  const defaultBoneColor = useSkeletonBoneColor();
  const opacity = context?.opacity ?? fallbackOpacity;
  const boneColor = context?.boneColor ?? defaultBoneColor;

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  return (
    <Animated.View
      style={[
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: boneColor,
        },
        animatedStyle,
        style,
      ]}
    />
  );
});

SkeletonCircle.displayName = 'SkeletonCircle';
